import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=1fa1d75c&scoped=true&"
import script from "./GlobalAlert.vue?vue&type=script&lang=js&"
export * from "./GlobalAlert.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAlert.vue?vue&type=style&index=0&id=1fa1d75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa1d75c",
  null
  
)

export default component.exports